<template>
    <v-app style="background-color: #d9dddd;" v-mutate="onMutate">
      <v-app-bar v-if="breakpoint < 1024" ref="toolbar" style="z-index: 150;"
        fixed app dense color="white" class="white--text text-uppercase">
        <v-app-bar-nav-icon class="red--text"
          @click.stop="drawer = true" aria-label="Настройки поиска"/>
        <a class="red--text" :href="homeURL || $appPath">
          <span class="body-2 font-weight-light red--text">
            КНИГИ В ГОРОДЕ.Проекты
          </span>
        </a>
        <v-spacer/>
        <span class="red--text font-weight-black subheading">
          {{
            [ Array.isArray(filters.days) ? filters.days[1] : filters.days ]
            | moment('DD/MM','','')
          }}
        </span>
      </v-app-bar>

      <v-navigation-drawer app flat
        :permanent="breakpoint >= 1024"
        v-model="drawer"
        disable-route-watcher
        v-bind:style="{
          'z-index': 200,
          width: $vuetify.breakpoint.width < 375 ? '250px !important' : '300px !important'
        }"
      >
          <v-layout fluid fixed pa-0 ma-0 wrap row>
            <div :style="{
                  'background-color': $appLogoBgColor,
                  'width': '100%',
                  'height': '150px',
                  'position': 'fixed',
                }"
            >
              <a :href="homeURL || $appPath">
                <img :alt="applicationTitle" :title="applicationTitle"
                  :src="require('../src/assets/logos/' + logoPrev)"
                  ref="logo"
                  @load="logoOnLoad"
                  :style="logoStyle"/>
              </a>
            </div>
            <!--
            <v-flex xs12
              style="position: absolute; top: 150px; bottom: 150px;
              overflow: hidden;
              overflow-y: scroll
            "> -->
            <v-flex xs12
              style="position: absolute; top: 150px; bottom: 50px;
              overflow: hidden;
              overflow-y: scroll;
            ">
              <div>
              <!--- :style="{ paddingTop: ($refs.logo && $refs.logo.height || 0) + 'px' }"> -->
                <social-sharing
                  :url="socialParams.url"
                  :title="socialParams.title"
                  :description="socialParams.quote"
                  :quote="socialParams.quote"
                  hashtags="КНИГИВГОРОДЕ_ПРОЕКТЫ,КНИГИВГОРОДЕ_ПРОЕКТЫ,КНИГИВГОРОДЕ"
                  twitter-user=""
                  inline-template
                  :class="{
                    'pl-2': true,
                    visibilityHidden: !($route.name === 'agenda' || !event)
                  }"
                >
                  <div>
                    <network
                      v-for="item in $store.state.socialNetworks"
                      :network="item.action"
                      :key="item.action"
                    >
                      <v-btn
                        small text icon
                        :color="$theme.color" :aria-label="'Поделиться: ' + item.action"
                      >
                        <font-awesome-icon :icon="item.icon" />
                      </v-btn>
                    </network>
                    <v-btn
                      small text icon :color="$theme.color" :aria-label="'Скопировать адрес'"
                      @click="$copyText($getLocation())"
                    >
                      <font-awesome-icon :icon="['fas', 'link']" />
                    </v-btn>
                  </div>
                </social-sharing>
                <Filters
                  :class="{ blockOpacity: $route.name === 'event', filters: true }"
                  :formats="formats"
                  v-on:close-drawer="closeDrawer"/>
              </div>
            </v-flex>
          </v-layout>
      </v-navigation-drawer>
      <v-main
        v-bind:style="{
          'padding-left': $vuetify.breakpoint.width < 769 ? '0px !important' : '300px !important',
        }"
        >
        <v-container ref="main" fluid>
          <v-progress-linear
            indeterminate
            color="primary darken-2"
            absolute
            top
            style="z-index: 140"
            v-if="progressActive"
          ></v-progress-linear>
          <v-row
              class="formats pa-7 pb-1 pt-3"
              :style="{ top: breakpoint < 1024 ? '48px' : '0px' }"
              v-if="$route.name === 'agenda' && agenda && agenda.filters"
          >
            <template
              v-if="agenda.filters.formats"
            >
              <v-chip
                class="rounded-0 mr-2 mb-2 text-uppercase"
                v-bind:key="i" ripple
                v-for="(e, i) in agenda.filters.formats"
                label
                @click="updateFormat(e)"
                :color="e.value === filters.formats ? 'primary' : 'white'"
                :close="e.value === filters.formats"
                @click:close="updateFormat(e)"
              >
                  {{ e.text }}
              </v-chip>
            </template>
            <v-chip
                class="rounded-0 mr-2 mb-2 text-uppercase"
                label
                color="white"
                :to="{ name: 'map', query: $route.query }"
                v-if="$filtersVisible.map"
              >
                  <v-icon>mdi-map</v-icon>
            </v-chip>
          </v-row>
          <router-view/>
        </v-container>
      </v-main>
    </v-app>
</template>

<script>
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
// import Axios from 'axios';
import { mapState } from 'vuex';
import Filters from '@/components/Filters.vue';

export default {
  components: {
    Filters,
  },
  data() {
    return {
      drawer: false,
      mainWidth: 0,
      hideTimeout: false,
      drawerCounter: 0,
      logoPrev: 'logo_default.png',
      logoStyle: {
        width: '300px',
        height: 'auto',
        'max-height': '150px',
      },
      formats: { value: '', version: 0 },
      homeURL: false,
    };
  },
  mounted() {
    this.onMutate();
    this.updateBreakpoint();
    this.logoPrev = this.logo;
  },
  methods: {
    updateFormat(v) {
      if (this.filters.formats === v.value) {
        this.formats = {
          value: '',
          version: this.formats.version + 1,
        };
      } else {
        this.formats = {
          value: v.value,
          version: this.formats.version + 1,
        };
      }
    },
    logoOnLoad() {
      const img = this.$refs.logo;
      const timg = new Image();
      timg.onload = () => {
        const w = timg.width > 300 ? 300 : timg.width;
        this.logoStyle.width = `${w}px`;
      };
      timg.src = img.src;
    },
    updateBreakpoint() {
      const val = this.$vuetify.breakpoint.width;
      let bp = 375;
      if (val >= 0 && val <= 768) bp = 375;
      if (val > 768 && val < 1024) bp = 1024;
      if (val >= 1024 && val < 1680) bp = 1680;
      if (val >= 1680) bp = 1920;
      this.$store.dispatch('updateBreakpoint', bp);
    },
    closeDrawer() {
      this.drawer = false;
    },
    onMutate() {
      let height = 0;
      const { toolbar, main } = this.$refs;
      if (main) {
        this.mainWidth = main.clientWidth;
      }
      if (toolbar) {
        height = `${4 + toolbar.$el.offsetHeight}px`;
      } else {
        height = '4px';
      }
      document.documentElement.style.setProperty('--headerHeight', height);
    },
  },
  computed: {
    ...mapState(['filters', 'event', 'applicationTitle', 'breakpoint', 'agenda', 'progressActive', 'logo']),
    socialParams() {
      const title = [];
      const quote = [];
      const what = [this.applicationTitle];
      const { filters } = this;
      const { event } = this;

      let day = filters.days || '';
      if (day && Array.isArray(day)) [day] = day;
      if (day) title.push(day);

      if (!event) {
        if (filters.zones !== false) title.push(filters.zones);
        if (filters.types !== false) what.push(filters.types);
        if (filters.days !== false) quote.push(`Когда: ${filters.days}`);
        quote.push(`Что: ${what.join(', ')}`);
        if (filters.zones !== false) quote.push(`Где: ${filters.zones}`);
      }

      title.push(this.applicationTitle);
      return {
        title: title.join(', '),
        url: window.location.toString(),
        quote: quote.join('\n'),
      };
    },
  },
  watch: {
    agenda(val) {
      const project = (val?.params?.projects || '').trim();
      if (project.length > 0) {
        this.homeURL = `${this.$appPath}?projects=${project}`;
      } else {
        this.homeURL = false;
      }
    },
    logo(val) {
      setTimeout(() => {
        this.logoPrev = val;
      }, 500);
    },
    '$route.name': {
      handler() {
        if (this.$route.name === 'agenda') this.drawer = true;
        if (this.drawerCounter > 0) this.drawer = false;
        this.drawerCounter += 1;
      },
    },
    filters: {
      deep: true,
      handler() {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = setTimeout(() => {
          // this.drawer = false;
        }, 5000);
      },
    },
    '$store.state.filters.lang': {
      handler(value) {
        this.$i18n.locale = value;
      },
    },
    '$vuetify.breakpoint.width': {
      handler() {
        this.updateBreakpoint();
      },
    },
  },
};
</script>

<style>
  * {
    /* font-family: 'GreekFallback, Calibri, "Gill Sans", "Gill Sans MT", Myriad Pro, Myriad, "Liberation Sans", "Nimbus Sans L", Tahoma, Geneva, "Helvetica Neue", Helvetica, Arial, sans-serif'; */
    font-family: 'Formular Light';
    word-break: normal;
  }
  .v-toolbar {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .visibilityHidden {
    visibility: hidden;
    opacity:0;
    transition:visibility 0.3s linear,opacity 0.3s linear;
  }
</style>
<style scoped>
  .formats {
    background: rgb(217, 221, 221); position: sticky; z-index: 100;
  }
  .filters {
    filter: blur(0);
    opacity: 1;
    transition: .5s ease-in-out;
  }
  .blockOpacity {
    opacity: 0.50;
    pointer-events: none;
    filter: blur(4px);
  }
</style>
